import { withDependencies } from '@wix/thunderbolt-ioc'
import { IPageDidMountHandler, CurrentRouteInfoSymbol } from '@wix/thunderbolt-symbols'
import { ICurrentRouteInfo } from 'feature-router'
import { IReporterApi } from '../types'
import { ReporterSymbol } from '../symbols'
import { reportPageView } from './report-page-view'
import { IPageNumber, PageNumberSymbol } from 'feature-business-logger'

const reporterNavigationHandlerFactory = (
	reporterApi: IReporterApi,
	currentRouteInfo: ICurrentRouteInfo,
	pageNumber: IPageNumber
): IPageDidMountHandler => ({
	pageDidMount: () => reportPageView(reporterApi, currentRouteInfo, pageNumber),
})

export const ReporterNavigationHandler = withDependencies(
	[ReporterSymbol, CurrentRouteInfoSymbol, PageNumberSymbol],
	reporterNavigationHandlerFactory
)
